import { useModalHook } from '@/components/commons/modals/useModalHook';
import { amlQueryParamsRecoil, chatUserInfoRecoil, mhQueryParamsRecoil } from '@/recoil/atoms/chatRoom';
import {
  addModalOpenRecoil,
  addModalTitleRecoil,
  mobileBuddyListAddRecoil,
  syncLoadingRecoil,
} from '@/recoil/atoms/MobileRecoil/MobileRecoil';
import { validatePhoneNumber } from '@/shared/util/AddressUtils';
import { removeHyphens, TelHyphen } from '@/shared/util/format/phoneNumberFormatUtil';
import { useQueryClient } from '@tanstack/react-query';
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';
import * as S from './SearchAddComponents.style';
import { LuMessageSquarePlus } from 'react-icons/lu';
import NoData from '@/components/common/NoData';

interface ISearchAddComponents {
  defaultNumber: string;
}

const SearchAddComponents: React.FC<ISearchAddComponents> = ({ defaultNumber }) => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const inputRef = useRef<HTMLInputElement>(null);

  const [firstInputValue, setFirstInputValue] = useState<string>(defaultNumber ?? '');

  //모바일 로딩 리코일
  const setSyncLoadingS = useSetRecoilState(syncLoadingRecoil);
  // 추가 방 상태 리코일
  const setAddModalOpenS = useSetRecoilState(addModalOpenRecoil);
  // 추가 방 제목 리코일
  const [addModalTitleS, setAddModalTitleS] = useRecoilState(addModalTitleRecoil);

  // 채팅 리스트 params recoil
  const [amlQueryParamsS, setAmlQueryParamsS] = useRecoilState(amlQueryParamsRecoil);

  // 1:1 채팅룸 번호로 생성할때 쓰일 아이들
  const [, setMhQueryParams] = useRecoilState(mhQueryParamsRecoil);
  const setMobileBuddyListAddS = useSetRecoilState(mobileBuddyListAddRecoil);
  /* 활성화 채팅방의 상대방 정보 */
  const setChatUserInfo = useSetRecoilState(chatUserInfoRecoil);

  const { customWarningModal, confirmModal, warningModal } = useModalHook();

  // 채팅 리스트
  const searchList = queryClient.getQueryData(['/smt/history/latest/app', amlQueryParamsS]);

  useEffect(() => {
    inputRef.current?.focus(); // 컴포넌트가 마운트되면 포커스
  }, []);

  const onChangeFirstInputValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setFirstInputValue(value);
  };

  //번호로 채팅방 생성
  const onClickCreateChatroom = () => {
    // 밸리데이트로 핸드폰 번호를 제대로 입력했을 때
    if (validatePhoneNumber(removeHyphens(TelHyphen(firstInputValue)))) {
      // confirmModal(
      //   async () => {
      //     try {
      //       navigate(`/mobile/message/messageList/${firstInputValue}`);
      //       setChatUserInfo({ phoneNumber: removeHyphens(TelHyphen(firstInputValue)), buddyName: '' });
      //       setMobileBuddyListAddS([
      //         {
      //           buddySeqNo: 0,
      //           buddyNm: '',
      //           keyCommNo: removeHyphens(TelHyphen(firstInputValue)),
      //         },
      //       ]);
      //       setMhQueryParams((prevState: any) => {
      //         return {
      //           ...prevState,
      //           contactNumber: removeHyphens(TelHyphen(firstInputValue)),
      //         };
      //       });
      //       setAddModalOpenS(false);
      //       setAddModalTitleS('');
      //     } catch {
      //       // 에러 핸들링
      //       customWarningModal(
      //         async () => {
      //           navigate(-1);
      //           setAddModalOpenS(false);
      //           setAddModalTitleS('');
      //         },
      //         '오류',
      //         '주소록 생성 중 오류가 발생했습니다.',
      //         true,
      //       );
      //     }
      //   },
      //   `'${TelHyphen(firstInputValue)}'`,
      //   `지정한 번호로 채팅방을 생성 하시겠습니까?`,
      //   true,
      // );

      try {
        navigate(`/mobile/message/messageList/${firstInputValue}`);
        setChatUserInfo({ phoneNumber: removeHyphens(TelHyphen(firstInputValue)), buddyName: '' });
        setMobileBuddyListAddS([
          {
            buddySeqNo: 0,
            buddyNm: '',
            keyCommNo: removeHyphens(TelHyphen(firstInputValue)),
          },
        ]);
        setMhQueryParams((prevState: any) => {
          return {
            ...prevState,
            contactNumber: removeHyphens(TelHyphen(firstInputValue)),
          };
        });
        setAddModalOpenS(false);
        setAddModalTitleS('');
      } catch {
        // 에러 핸들링
        customWarningModal(
          async () => {
            navigate(-1);
            setAddModalOpenS(false);
            setAddModalTitleS('');
          },
          '오류',
          '주소록 생성 중 오류가 발생했습니다.',
          true,
        );
      }
    } else {
      // 번호 이상하게 넣었을 때
      warningModal('경고', '유효하지 않은 번호 형식 입니다.', true);
    }
  };

  return (
    <>
      <S.MessageListContainer onClick={() => onClickCreateChatroom()}>
        <S.MessageImage>
          <LuMessageSquarePlus size={'2.4rem'} />
        </S.MessageImage>
        <S.MessageContents>
          <S.AddMain>
            <p>대화하기</p>
            <S.AddInput
              onClick={(e) => {
                if (!TelHyphen(defaultNumber)) {
                  e.stopPropagation(); // 클릭 이벤트 전파를 막음
                }
              }}
              value={TelHyphen(firstInputValue)}
              onChange={onChangeFirstInputValue}
              type="text"
              placeholder="번호를 입력해 주세요."
              maxLength={50}
              readOnly={TelHyphen(defaultNumber) ? true : false}
            />
          </S.AddMain>
        </S.MessageContents>
      </S.MessageListContainer>
      <NoData heightPercent={50} content="데이터 없음" />
    </>
  );
};

export default SearchAddComponents;
